<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel"
    style="padding-top: 20px;">
    <!-- <ol class="carousel-indicators">
      <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
      <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
      <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
    </ol> -->

    <div class="carousel-inner">
      <!-- carousel-item active -->
      <div
        *ngFor="let banner of banner; let i = index"
        [ngClass]="(i === 0) ? 'carousel-item active' : 'carousel-item'"
        data-interval="10000"
      >
        <a href="{{banner['url']}}">
            <img src="{{banner['img']}}" class="d-block w-100" alt="{{banner['name']}}">
        </a>
      </div>

    </div>
    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>

<div class="container-fuild" style="padding-top: 5px; padding-bottom: 5px;">
  <div class="row" style="background-color: #fff;">
    <div class="col-12 col-sm-6 col-md-6 col-lg-6">
      <div>
        <a href="https://www.apu-school.com/t/?line" target="_blank">
        <img
          class="img-fluid"
          src="https://assets.dekthai-online.com/static/line.png">
        </a>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-md-6 col-lg-6">
      <div>

        <a href="https://www.youtube.com/user/apuolympics" target="_blank">
        <img
          class="img-fluid"
          src="https://assets.dekthai-online.com/static/line-2.png">
        </a>
      </div>
    </div>
  </div>
</div>